import { Zap, Target, Layers } from "lucide-react";

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-16 md:py-24 bg-[#050505] overflow-hidden"
    >
      <div className="absolute -left-20 top-1/3 h-[420px] w-[420px] rounded-full bg-[#007AFF]/10 blur-[140px]" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-12 gap-8 md:gap-12 items-start">
        {/* Left: heading + paragraph */}
        <div className="col-span-12 lg:col-span-7 reveal">
          <div className="text-xs font-bold tracking-[0.22em] uppercase text-[#00F0FF]">
            / About
          </div>
          <h2 className="mt-4 font-display text-5xl md:text-6xl font-extrabold leading-[0.95] tracking-[-0.03em]">
            We build the operating
            <br />
            system for ambitious
            <br />
            <span className="text-gradient-blue">UK businesses.</span>
          </h2>

          <div className="mt-10 max-w-xl text-slate-300 text-lg leading-relaxed space-y-5">
            <p>
              BrandWithAbdo is a forward-thinking studio for founders who refuse
              templates, agencies, and excuses. We treat your business like a
              product — every interaction designed, every system measured.
            </p>
            <p className="text-slate-400">
              The result: websites that convert, systems that compound, and
              marketing that pays for itself. No fluff. No middlemen. Just
              senior engineering and design, shipping every week.
            </p>
          </div>
        </div>

        {/* Right: pillars */}
        <div className="col-span-12 lg:col-span-5 reveal">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {[
              { icon: Zap, t: "Senior-only team", d: "Every line written by people who've shipped to millions." },
              { icon: Target, t: "Outcome-led", d: "We're paid to grow your numbers, not bill you for hours." },
              { icon: Layers, t: "End-to-end", d: "Strategy → design → build → growth, all under one roof." },
              { icon: Zap, t: "UK-based, global thinking", d: "Premium product standards from a London-rooted studio." },
            ].map((p, i) => (
              <div
                key={i}
                data-testid={`about-pillar-${i}`}
                className="glass rounded-2xl p-6 hover:border-[#007AFF]/40 transition-colors"
              >
                <span className="grid place-items-center h-10 w-10 rounded-xl bg-[#007AFF]/15 border border-[#007AFF]/30">
                  <p.icon className="h-4.5 w-4.5 text-[#00F0FF]" />
                </span>
                <h4 className="mt-5 font-display font-bold text-lg">{p.t}</h4>
                <p className="mt-2 text-sm text-slate-400 leading-relaxed">{p.d}</p>
              </div>
            ))}
          </div>

          <div className="mt-6 glass-strong rounded-2xl p-6 flex items-center gap-5">
            <div className="font-display text-5xl font-black text-[#00F0FF]">7+</div>
            <div className="text-sm text-slate-300 leading-relaxed">
              years building digital products & growth systems for SMBs and
              VC-backed startups.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
